import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { Route, Switch, Redirect } from "react-router-dom";
import { withRouter } from "react-router";
import Spinner from "react-spinkit";
import Delay from 'react-delay';
import AriaModal from 'react-aria-modal';

import { clearMessages, finishLoading } from "~app/actions/app";

import Main from "~app/pages/Main/Main";
import IntroRouter from "~app/pages/intro/IntroRouter";
import About from "~app/pages/About";
import Resources from "~app/pages/Resources";
import Help from "~app/pages/Help";
import Glossary from "~app/pages/Glossary";
import Footer from "~app/components/Footer";
import SkipLink from '~app/components/SkipLink/SkipLink';
import SkipLinkContainer from './components/SkipLink/SkipLinkContainer';
import { withT } from '~app/BundleProvider';

class App extends React.Component {
  constructor(props) {
    super(props);

    this.appRef = null;
    this.mainContentRef = null;
    this.navRef = null;
  }

  componentDidMount() {
    // if browser was reloaded, redirect back to title page

    if (performance.navigation.type === 1) {
      this.handleUnload();
    }
  }

  componentDidUpdate(prevProps){
    if(prevProps.location !== this.props.location){
      if (this.appRef) this.appRef.focus();
    }
  }

  handleUnload = () => {
    this.props.history.push('/intro');
  }

  setAppRef = element => {
    this.appRef = element;
  };

  setMainContentRef = element => {
    this.mainContentRef = element;
  };

  setNavRef = element => {
    this.navRef = element;
  };

  focusContent = () => {
    if (this.mainContentRef) this.mainContentRef.focus();
  };

  focusNav = () => {
    if (this.navRef) this.navRef.focus();
  };

  render() {
    const { isLoading, loadingMessage, messages, clearMessages, t } = this.props;

    return (
      <React.Fragment>
        <div className="Root" ref={this.setAppRef} tabIndex="-1">
          <SkipLinkContainer>
            <SkipLink
              ariaLabel={t("skip-to-main-label")}
              onSkip={this.focusContent}
            >
              {t("skip-to-main")}
            </SkipLink>
            <SkipLink
              ariaLabel={t("skip-to-nav-label")}
              onSkip={this.focusNav}
            >
              {t("skip-to-nav")}
            </SkipLink>
          </SkipLinkContainer>
          <div className="not_footer">
            <Switch>
              <Route exact path="/" render={() => <Redirect to="/intro" />} />
              <Route path="/intro" render={() => <IntroRouter mainRef={this.setMainContentRef} navRef={this.setNavRef} />} />
              <Route exact path="/main" render={() => <Main mainRef={this.setMainContentRef} />} />
              <Route exact path="/about" render={() => <About mainRef={this.setMainContentRef} />} />
              <Route exact path="/resources" render={() => <Resources mainRef={this.setMainContentRef} />}/>
              <Route exact path="/help" render={() => <Help mainRef={this.setMainContentRef} />} />
              <Route exact path="/glossary" render={() => <Glossary mainRef={this.setMainContentRef} />} />
              <Route path="/" render={() => <div>Not found</div>} />
            </Switch>
          </div>
          <Footer navRef={this.setNavRef}/>
        </div>

        <Delay wait={2000}>
          <AriaModal
            mounted={isLoading}
            onExit={finishLoading}
            titleText="loading"
            underlayColor="rgba(0,0,0,0)"
            // underlayClass="PopupBackdrop"
            focusDialog={true}
            focusTrapPaused={true}
            >
              <div className="PopupContent__layout">
                <div
                  className="PopupContent__cancel"
                  role="button"
                  tabIndex="0"
                  onClick={finishLoading}
                  onKeyPress={(event) => {
                    if(event.key === 'Enter' || event.key === ' '){
                      finishLoading(event);
                    }
                  }}>
                  &times;
                </div>
                <div className="PopupContent__text-group">
                  <h1>{loadingMessage}</h1>
                </div>
                <div className="PopupContent__loading-spinner">
                  <Spinner name="ball-spin-fade-loader" color="#9edd87" />
                </div>
              </div>
          </AriaModal>
        </Delay>

        {messages.map(m => (

          <AriaModal
            key={m.message}
            // mounted={true}
            onExit={clearMessages}
            titleText={m.message}
            underlayColor="rgba(0,0,0,0)"
            // underlayClass="PopupBackdrop"
            >
            <div className={`PopupContent__layout ${m.type}`}>
              <div className="PopupContent__text-group">
                <h1 id="modal-message">{m.message}</h1>
                {m.subMessage && <h3>{m.subMessage}</h3>}
              </div>
              <div className="PopupContent__btn-group">
                <button onClick={clearMessages}>OK</button>
              </div>
            </div>
          </AriaModal>

        ))}
      </React.Fragment>
    );
  }
}

App.propTypes = {
  history: PropTypes.object.isRequired,
  clearMessages: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  loadingMessage: PropTypes.string,
  messages: PropTypes.array,
};

App.defaultProps = {
  loadingMessage: "",
  messages: [],
};

const mapStateToProps = ({ app }) => ({
  isLoading: app.isLoading,
  loadingMessage: app.loadingMessage,
  messages: app.messages,
});

const mapDispatchToProps = {
  clearMessages,
  finishLoading,
};

export default withRouter(withT(connect(mapStateToProps, mapDispatchToProps)(App)));



// WEBPACK FOOTER //
// ./src/App.js